import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {MessageModel} from '../../../api/model/messageModel';
import {MessageConverter} from '../../../api/model/converter/message.converter';
import {AbstractDataServiceV2} from '../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable()
export class MessageDataService extends AbstractDataServiceV2<MessageModel, MessageConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: MessageConverter) {
        super('Message', http, httpUrlGenerator, logger, config, converter);
    }
}
